/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio manager API
 * API for tracking portfolio management
 *
 * OpenAPI document version: 1.0.0
 *
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class PropertiesApi extends runtime.BaseAPI {
    /**
     */
    async createPropertyRaw(requestParameters, initOverrides) {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling createProperty().');
        }
        if (requestParameters['createPropertyDto'] == null) {
            throw new runtime.RequiredError('createPropertyDto', 'Required parameter "createPropertyDto" was null or undefined when calling createProperty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwt", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/organizations/{organizationId}/properties`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createPropertyDto'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async createProperty(requestParameters, initOverrides) {
        const response = await this.createPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async deletePropertyRaw(requestParameters, initOverrides) {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling deleteProperty().');
        }
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError('propertyId', 'Required parameter "propertyId" was null or undefined when calling deleteProperty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwt", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/organizations/{organizationId}/properties/{propertyId}`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async deleteProperty(requestParameters, initOverrides) {
        await this.deletePropertyRaw(requestParameters, initOverrides);
    }
    /**
     */
    async getPropertiesRaw(requestParameters, initOverrides) {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getProperties().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwt", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/organizations/{organizationId}/properties`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProperties(requestParameters, initOverrides) {
        const response = await this.getPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async getPropertyRaw(requestParameters, initOverrides) {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling getProperty().');
        }
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError('propertyId', 'Required parameter "propertyId" was null or undefined when calling getProperty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwt", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/organizations/{organizationId}/properties/{propertyId}`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async getProperty(requestParameters, initOverrides) {
        const response = await this.getPropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updatePropertyRaw(requestParameters, initOverrides) {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling updateProperty().');
        }
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError('propertyId', 'Required parameter "propertyId" was null or undefined when calling updateProperty().');
        }
        if (requestParameters['updatePropertyDto'] == null) {
            throw new runtime.RequiredError('updatePropertyDto', 'Required parameter "updatePropertyDto" was null or undefined when calling updateProperty().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwt", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/organizations/{organizationId}/properties/{propertyId}`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updatePropertyDto'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updateProperty(requestParameters, initOverrides) {
        const response = await this.updatePropertyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updatePropertyNotesRaw(requestParameters, initOverrides) {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError('organizationId', 'Required parameter "organizationId" was null or undefined when calling updatePropertyNotes().');
        }
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError('propertyId', 'Required parameter "propertyId" was null or undefined when calling updatePropertyNotes().');
        }
        if (requestParameters['updatePropertyNotesDto'] == null) {
            throw new runtime.RequiredError('updatePropertyNotesDto', 'Required parameter "updatePropertyNotesDto" was null or undefined when calling updatePropertyNotes().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwt", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/organizations/{organizationId}/properties/{propertyId}/notes`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));
        urlPath = urlPath.replace(`{${"propertyId"}}`, encodeURIComponent(String(requestParameters['propertyId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['updatePropertyNotesDto'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     */
    async updatePropertyNotes(requestParameters, initOverrides) {
        const response = await this.updatePropertyNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=properties-api.js.map